__turbopack_context__.v({
  "className": "geist_mono_7e641024-module__MsYPGq__className",
  "variable": "geist_mono_7e641024-module__MsYPGq__variable",
});
